<template>
  <div id="mainmenu" class="menu_container">
    <label class="mobile_collapser">MENU</label>
    <ul>
      <li class="active"><a href="/">{{$store.state.text.menu.home}}</a></li>
      <li><a href="#contact">{{$store.state.text.menu.contact}}</a></li>
    </ul>
  </div>
</template>

<script>
export default {
name: "MenuTop"
}
</script>

<style scoped>

</style>